import * as React from "react";
export class Possession extends React.PureComponent {
    render() {
        const clsMdf = this.props.modifier ? ` rj-scoreboard__possession--${this.props.modifier}` : "";
        const clsSevice = this.props.onService ? " rj-scoreboard__possession--service" : "";
        return (React.createElement("span", { className: `rj-scoreboard__possession${clsMdf}${clsSevice}` }, " "));
    }
}
//# sourceMappingURL=Possession.js.map